export const messengerSettings = {
  ACCEPTED_IMAGE_TYPES: 'png,jpg,jpeg,gif,tiff,webp',
  ACCEPTED_DOCUMENT_TYPES: 'doc,docx,ppt,pptx,xls,xlsx,pdf,key,keynote,numbers,odp,ods,odt,pages',
  ACCEPTED_ZIP_TYPES: '7z,arj,bz2,gz,rar,tgz,zip',
  MAX_IMAGE_SIZE_MB: 50,
  MAX_DOC_SIZE_MB: 100,
  MAX_LINES: 15,
  MAX_CHAR_COUNT: 8000,
  FILES_LIMIT: 20,
  MAX_CONTENT_LENGTH: 25,
  REFRESH_INTERVAL: 10000, //10seconds
}
